/** URLE DO ZEWNĘTRZNYCH SERWISÓW */
export const FAKTUROMANIA_FACEBOOK_PAGE_URL: string = 'https://www.facebook.com/fakturomania/';
export const FAKTUROMANIA_TWITTER_PAGE_URL: string = 'https://twitter.com/fakturomania';
export const FAKTUROMANIA_GOOGLE_PLUS_PAGE_URL: string = 'https://plus.google.com/+FakturomaniaPl';
export const FAKTUROMANIA_LINKED_IN_PAGE_URL: string = 'https://pl.linkedin.com/company/fakturomania-sp.-z-o.o.';
export const FAKTUROMANIA_YOUTUBE_PAGE_URL: string = 'https://www.youtube.com/channel/UCzmFMBY0A2wG5GgNUEg20Gg';
// PROFIL FIRMY W MAPACH GOOGLE (OPINIE) => PUSTY = PASEK DOWODÓW BEZ LINKU
export const FAKTUROMANIA_GOOGLE_OPINIE_URL: string = 'https://maps.google.com/?cid=11756285664289587868';

/** URLE DO WEWNĘTRZYCH STRON */
export const FAKTUROMANIA_KALKULATOR_WYNAGRODZEN_PAGE_URL: string = '/kalkulator-wynagrodzen';
export const FAKTUROMANIA_CENNIK_PAGE_URL: string = '/cennik';
export const FAKTUROMANIA_POROWNANIE_PAKIETOW_PAGE_URL: string = '/porownanie-pakietow';
export const FAKTUROMANIA_BIURO_RACHUNKOWE_PAGE_URL: string = '/biuro-rachunkowe';
export const FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL: string = '/zakladanie-spolek-zoo';
export const FAKTUROMANIA_NASZ_ZESPOL_PAGE_URL: string = '/nasz-zespol';
export const FAKTUROMANIA_COOKIES_PAGE_URL: string = '/cookies';
export const FAKTUROMANIA_REGULAMIN_PAGE_URL: string = '/regulamin';
export const FAKTUROMANIA_DOTACJE_PAGE_URL: string = '/dotacje';
export const FAKTUROMANIA_FAQ_PAGE_URL: string = '/faq';
export const FAKTUROMANIA_FUNKCJE_PAGE_URL: string = '/funkcje';
export const FAKTUROMANIA_KONTAKT_PAGE_URL: string = '/kontakt';
export const FAKTUROMANIA_LANDING_PAGE_URL: string = '/';
export const FAKTUROMANIA_LIKWIDACJA_SPOLEK_PAGE_URL: string = '/likwidacja-spolek';
export const FAKTUROMANIA_PROGRAM_DO_FAKTUR_PAGE_URL: string = '/program-do-faktur';
export const FAKTUROMANIA_POLITYKA_RACHUNKOWOSCI_PAGE_URL: string = '/polityka-rachunkowosci';

/** URLE DO APLIKACJI */
export const FAKTUROMANIA_REGISTRATION_PAGE_URL: string = 'https://app.fakturomania.pl/konto/rejestracja';
export const FAKTUROMANIA_LOGIN_PAGE_URL: string = 'https://app.fakturomania.pl/';
export const FAKTUROMANIA_KONTACT_FORM_API_URL: string = 'https://fakturomania.pl/api/v1/utility/contactForm';
export const FAKTUROMANIA_STAFF_CALCULATOR_API_URL: string = 'https://fakturomania.pl/api/v1/staff/staff-calculator';

/** */
export const FAKTUROMANIA_POLITYKA_RACHUNKOWOSCI_DOCX_PAGE_URL: string = `https://app.fakturomania.pl/static/POLITYKA-RACHUNKOWOSCI.docx`;
export const FAKTUROMANIA_POLITYKA_RACHUNKOWOSCI_PDF_PAGE_URL: string = `https://app.fakturomania.pl/static/POLITYKA-RACHUNKOWOSCI.pdf`;

/** ZAŁĄCZNIK NR 1 DO REGULAMINU => UMOWA POWIERZENIA (PDF, file-loader Gatsby wrzuca go do /static/ z hashem w nazwie) */
export const FAKTUROMANIA_UMOWA_POWIERZENIA_PDF_URL: string = require("../assets/universal/docs/zalacznik-nr-1-umowa-powierzenia-fakturomania.pdf");
/** POZOSTAŁE */
export const FAKTUROMANIA_PLANY_ROZWOJU_TRELLO_URL: string = 'https://trello.com/b/XAWlOwvp/fakturomania-plany-rozwoju';

/** BAZA WIEDZY */
export const FAKTUROMANIA_KNOWLEDGEBASE_URL: string = 'https://pomoc.fakturomania.pl';

/** BLOGOWE */
export const FAKTUROMANIA_BAZA_WIEDZY_PAGE_URL: string = 'https://pomoc.fakturomania.pl/support/home';
export const FAKTUROMANIA_JEDNOSTKI_MIKRO_ARTICLE_URL: string = 'https://pomoc.fakturomania.pl/support/solutions/articles/36000536473-jednostki-mikro-definicja-kryteria-i-uproszczenia';
export const FAKTUROMANIA_ZAKLADANIE_SPOLKI_BLOG_PAGE_URL: string = 'https://blog.fakturomania.pl/jak-zalozyc-spolke-zoo-przez-internet/';
export const FAKTUROMANIA_DLACZEGO_WARTO_ZALOZYC_SPOLKE_ZOO_BLOG_PAGE_URL: string = 'https://blog.fakturomania.pl/dlaczego-warto-zalozyc-spolke-zoo/';


// WEBPACK FOOTER //
// ./src/constants/static-urls.ts